import ym from 'react-yandex-metrika';

export const hit = path => {
  ym('hit', path);

	if(window.ga){
		window.ga('send', 'pageview', path);
	}
}